import React from 'react'

import styles from './index.module.scss'

function DemandsStep({ step, currentStepNumber }) {
	const isCurrent = step.step_number === currentStepNumber
	const isDone = step.step_number < currentStepNumber && currentStepNumber < 8

	return (
		<div
			className={styles.demandStepItem}
			data-current={isCurrent}
			data-done={isDone}>
			<div className={styles.demandStepItemHeader}>
				<h1
					className={styles.demandStepItemNumber}
					data-current={isCurrent}
					data-done={isDone}>
					{String(step.step_number).padStart(2, '0')}
				</h1>
				{isDone ? (
					<svg
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="currentColor"
						xmlns="http://www.w3.org/2000/svg"
						className={styles.demandStepItemIcon}>
						<path d="M8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM8 10C7.73366 10.006 7.4688 9.95877 7.22098 9.86103C6.97315 9.76328 6.74735 9.61701 6.55683 9.4308C6.36631 9.24458 6.21491 9.02218 6.11153 8.77666C6.00814 8.53113 5.95485 8.26742 5.95478 8.00101C5.95472 7.7346 6.00788 7.47087 6.11114 7.22529C6.2144 6.97971 6.36569 6.75723 6.55611 6.57093C6.74654 6.38462 6.97227 6.23823 7.22005 6.14036C7.46782 6.04249 7.73266 5.99511 7.999 6.001C8.52156 6.01256 9.01883 6.22822 9.38437 6.60184C9.74991 6.97545 9.95465 7.47732 9.95478 8.00001C9.95492 8.5227 9.75042 9.02467 9.38507 9.39847C9.01972 9.77227 8.52256 9.98818 8 10Z" />
					</svg>
				) : (
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="16"
						height="16"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
						className={styles.demandStepItemIcon}>
						<circle cx="12" cy="12" r="10" />
					</svg>
				)}
			</div>
			<p
				className={styles.demandStepContent}
				data-current={isCurrent}
				data-done={isDone}>
				{step.name}
			</p>
		</div>
	)
}

export default DemandsStep
